import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2, Check, AlertCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";

export default function RecurringConfirm() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!token) {
      setState("error");
      return;
    }
    api
      .post(`/recurring/confirm`, null, { params: { token } })
      .then((r) => {
        setState("ok");
        setTimeout(() => {
          window.location.href = `/pay/${r.data.booking_id}`;
        }, 1200);
      })
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0b0f17] text-slate-200">
      <Navbar />
      <section className="mx-auto max-w-lg px-4 py-24 text-center" data-testid="recurring-confirm-page">
        {state === "loading" && <Loader2 className="h-10 w-10 text-[#ff6b00] animate-spin mx-auto" />}
        {state === "ok" && (
          <>
            <div className="h-14 w-14 mx-auto rounded-full bg-emerald-500/15 flex items-center justify-center"><Check className="h-7 w-7 text-emerald-300" /></div>
            <h1 className="font-display uppercase text-2xl font-extrabold mt-4">You're booked in!</h1>
            <p className="text-sm text-slate-400 mt-2">Taking you to pay your deposit and lock it in…</p>
          </>
        )}
        {state === "error" && (
          <>
            <div className="h-14 w-14 mx-auto rounded-full bg-red-500/15 flex items-center justify-center"><AlertCircle className="h-7 w-7 text-red-300" /></div>
            <h1 className="font-display uppercase text-2xl font-extrabold mt-4">Link expired</h1>
            <p className="text-sm text-slate-400 mt-2">This confirmation link has expired or was already used. We'll check in with you next cycle, or you can book anytime.</p>
            <a href="/book" className="cj-btn-primary mt-5 inline-block px-6 py-3 rounded-full">Book now</a>
          </>
        )}
      </section>
      <Footer />
    </div>
  );
}
